/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AccountingReconciliation from './accounting-reconciliation';
import AccountingReconciliationDetail from './accounting-reconciliation-detail';
import AccountingReconciliationUpdate from './accounting-reconciliation-update';
import AccountingReconciliationDeleteDialog from './accounting-reconciliation-delete-dialog';

const AccountingReconciliationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AccountingReconciliation />} />
    <Route path="new" element={<AccountingReconciliationUpdate />} />
    <Route path=":id">
      <Route index element={<AccountingReconciliationDetail />} />
      <Route path="edit" element={<AccountingReconciliationUpdate />} />
      <Route path="delete" element={<AccountingReconciliationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AccountingReconciliationRoutes;
